import { Box, Grid, Typography } from '@mui/material'
import { useAppSelector } from 'app/hooks'
import EventCard from 'components/EventCard'
import { format } from 'date-fns'
import { ReactElement } from 'react'
import { useLocation } from 'react-router-dom'

export default function Home(): ReactElement {
  const urlQuery = new URLSearchParams(useLocation().search)
  let events = useAppSelector((s) => s.Event.list)
  if(urlQuery.get('organizer')) { 
    events = events.filter(
      (f) => f.organizerId === urlQuery.get('organizer')
    )
  }
  return (
    <Grid container spacing={2} mt={2}>
      <Grid item xs={12}>
        <Typography
          variant="h4"
          component="h2"
          sx={{ borderBottom: 2 }}
          fontWeight="bold"
        >
          イベント一覧
        </Typography>
      </Grid>
      {events.filter((f) => f.joins.length).length > 0 ? (
        <Grid item xs={12}>
          <Typography
            variant="h6"
            component="h3"
            sx={{ borderBottom: 1 }}
            fontWeight="bold"
          >
            参加中のイベント
          </Typography>
        </Grid>
      ) : (
        ''
      )}
      <Grid item xs={12}>
        {events
          .filter((f) => f.joins.length)
          .reverse()
          .map((event) => {
            return (
              <Box key={event.id} my={2}>
                <EventCard
                  to={'/event/' + event.id}
                  place={event.address}
                  title={event.name}
                  time={`${format(event.startDate, 'yyyy/MM/dd')} ～ ${format(
                    event.endDate,
                    'yyyy/MM/dd'
                  )}`}
                  summary={event.summary}
                  src={`${
                    process.env.NODE_ENV === 'development'
                      ? 'http://localhost:5000'
                      : ''
                  }${event.image}`}
                />
              </Box>
            )
          })}
      </Grid>
      <Grid item xs={12}>
        <Typography
          variant="h6"
          component="h3"
          sx={{ borderBottom: 1 }}
          fontWeight="bold"
        >
          開催中のイベント
        </Typography>
      </Grid>
      <Grid item xs={12}>
        {events
          .filter((f) => !f.joins.length)
          .reverse()
          .map((event) => {
            return (
              <Box key={event.id} my={2}>
                <EventCard
                  to={'/event/' + event.id}
                  place={event.address}
                  title={event.name}
                  time={`${format(event.startDate, 'yyyy/MM/dd')} ～ ${format(
                    event.endDate,
                    'yyyy/MM/dd'
                  )}`}
                  summary={event.summary}
                  src={`${
                    process.env.NODE_ENV === 'development'
                      ? 'http://localhost:5000'
                      : ''
                  }${event.image}`}
                />
              </Box>
            )
          })}
      </Grid>
    </Grid>
  )
}
